import { instance as axiosInstance } from './base';
import config from './config/index';
/**
 * 发送请求公共方法
 * desc - 请求描述
 * method - 请求类型
 * url - 请求url, url中可以加入一些插值如/companies/{company_id}，params中传入company_id就会替换url的company_id
 * mock - 是否mock
 * response - mock后的response返回  定义response见mockjs文档：http://mockjs.com/examples.html
 */
class ApiService {
  static config = config;
  get config() {
    return ApiService.config;
  }

  /**
   *
   * @param config
   * @param params
   * @param options
   *  - options. 后续可以加一些 loading 缓存等配置项
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  request(config, params = {}, options = {}) {
    // 替换url中的变量
    const requestConfig = { ...config };
    const { url, requestParams } = parseUrl(requestConfig.url, params);
    requestConfig.url = url;

    if (requestConfig.method === 'post' || requestConfig.method === 'put') {
      requestConfig.data = requestParams;
    } else {
      requestConfig.params = requestParams;
    }
    requestConfig.options = options;

    return axiosInstance.request(requestConfig);
  }
}

function parseUrl(str, obj) {
  let url = str;
  const requestParams = obj;
  Object.keys(obj).forEach((key) => {
    const regex = new RegExp(`{${key}}`, 'g');
    if (str.match(regex)) {
      url = str.replace(regex, obj[key]);
      delete requestParams[key];
    }
  });
  return { url, requestParams };
}

export const Api = new ApiService();
export const ApiConfig = ApiService.config;
